export const blockIconsTravelNightShelterNew = (
	<span className='material-symbols-outlined'>night_shelter</span>
);
